import apolloClient from "../apolloClient";
import { GET_INVOICE } from "./graphql";

class InvoiceService {
	async get(checkoutId) {
		const { data } = await apolloClient.query({
			query: GET_INVOICE,
			variables: {
				checkoutId,
			},
		});
		return data.orders.nodes[0];
	}
}

export default new InvoiceService();
